import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import view from 'assets/images/table/view.svg'
import deleteIcon from 'assets/images/table/delete.svg'
import edit from 'assets/images/table/icon.svg'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useSelector } from 'react-redux'
// ii18n
interface IProps {
  className?: string
  viewLink?: string
  editLink?: string
  Module: string | null
  editButton?: () => void
  delete?: { handleDelete: any }
}
export default function Actions(props: IProps): JSX.Element {
  const { t } = useTranslation() // ti18n
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()
  const permitions = useSelector((state: any) => state?.UserInfo?.user?.Permissions)
  const thisTablePermisstions = permitions.find((ele: any) => ele.Module === props.Module)
  return (
    <div className={`flex justify-center ${props.className ?? ''}`}>
      {props.viewLink && thisTablePermisstions?.View && (
        <Link to={props.viewLink} className="">
          <img src={view} alt="view" className="w-5 h-5 object-contain mx-2" />
        </Link>
      )}

      {props.editLink && thisTablePermisstions?.Edit && (
        <Link to={props.editLink} className="">
          <img src={edit} alt="history" className="w-5 h-5 object-contain mx-2 p-[2px]" />
        </Link>
      )}

      {props.editButton && thisTablePermisstions?.Edit && (
        <button type="button" onClick={props.editButton} className="">
          <img src={edit} alt="history" className="w-5 h-5 object-contain mx-2 p-[2px]" />
        </button>
      )}

      {props.delete && thisTablePermisstions?.Delete && (
        <div>
          <button type="button" className="" onClick={onOpen}>
            <img src={deleteIcon} alt="deleteIcon" className="w-4 h-4 object-contain mx-2" />
          </button>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <div dir="">
              <ModalContent>
                <ModalHeader>
                  <p className="text-primary-500">{t('Delete Item')}</p>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <p className="text-base font-bold text-center">
                    {t('Are you sure to delete item?')}
                  </p>
                </ModalBody>
                <ModalFooter>
                  <div className="flex justify-end">
                    {props?.delete && (
                      <button
                        type="button"
                        className="btn-white-outline bg-red-700 text-white mx-2"
                        onClick={() => {
                          const deleteAction = props.delete?.handleDelete()
                          const deletePromise = deleteAction?.unwrap
                            ? deleteAction.unwrap()
                            : deleteAction
                          Promise.resolve(deletePromise)
                            .then(() => {
                              onClose()
                              toast({
                                description: t('Deleted successfully'),
                                position: 'top-right',
                                status: 'success',
                                duration: 5000,
                              })
                            })
                            .catch(error => {
                              onClose()
                              toast({
                                description: t('Failed to delete'),
                                position: 'top-right',
                                status: 'error',
                                duration: 5000,
                              })
                            })
                        }}>
                        {t('confirm Delete')}
                      </button>
                    )}
                    <button type="button" onClick={onClose} className="btn-white-outline mx-2">
                      {t('Cancel')}
                    </button>
                  </div>
                </ModalFooter>
              </ModalContent>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}
